import { render, staticRenderFns } from "./SatelliteSharedFieldDetail.vue?vue&type=template&id=37a9309a&scoped=true&"
import script from "./SatelliteSharedFieldDetail.vue?vue&type=script&lang=js&"
export * from "./SatelliteSharedFieldDetail.vue?vue&type=script&lang=js&"
import style0 from "./SatelliteSharedFieldDetail.vue?vue&type=style&index=0&id=37a9309a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9309a",
  null
  
)

export default component.exports